import React from 'react';
import { Link } from 'react-router-dom';

export const Home = () => {
    return <>
    <div>
         <h1 style={styles.home}>Home</h1>
    </div>
    <div style={styles.main}>
            
        </div>
        </>
       
       
       
    
} 

const styles = {
    main: {
        
        width: "1000px",
       height: "500px",
       marginLeft: " 250px ",
       backgroundRepeat: "no-repeat",
       
        display: "flex",
        backgroundImage: "url(https://images.unsplash.com/photo-1542722140-13cfa09585c7?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80)",
        
    },
    home: {

        textAlign: "center",
     
        color:"red"
    }
}